const GlobalCTA = ({ data }) => {
  if (!data) return null;

  return (
    <section className="mt-16 py-16 px-6 bg-gradient-to-br from-indigo-50 via-purple-50 to-blue-50 border-y border-gray-200" data-testid="global-cta-section">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap items-center justify-between gap-8">
          <div className="flex-1 min-w-[300px]">
            <h3 className="text-3xl font-bold mb-3 text-gray-900">{data.title}</h3>
            <p className="text-gray-600 leading-relaxed">{data.subtitle}</p>
          </div>

          <div className="flex flex-col items-start gap-4">
            <a
              href={data.buttonLink}
              className="px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold rounded-full hover:shadow-lg hover:shadow-purple-500/50 transition-all hover:-translate-y-1"
              data-testid="global-cta-button"
            >
              {data.buttonText}
            </a>
            <div className="flex items-center gap-3 text-sm text-gray-600">
              <span>Brought to you by</span>
              <a
                href="https://encoresvcsllc.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-blue-900 hover:underline"
              >
                Encore Services LLC
              </a>
              <a href="https://encoresvcsllc.com/" target="_blank" rel="noopener noreferrer">
                <img 
                  src="https://acusightpro.com/wp-content/uploads/2025/12/blue-encore-logo.png" 
                  alt="Encore Services LLC" 
                  className="h-5 w-auto hover:opacity-80 transition-opacity"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalCTA;
